import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AllReviewList, MobileReviewListingModel, ReviewListing } from 'src/app/models/review';
import { HomePageService } from 'src/app/services/home-page.service';
import { ReviewManagementService } from 'src/app/services/review-management.service';
import { ProductNameComponent } from '../product-name/product-name.component';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.css']
})
export class ReviewComponent implements OnInit {
  Loader: boolean = false;
  reviewListModel: ReviewListing = new ReviewListing();
  reviewsList: AllReviewList = new AllReviewList();
  totalPages: number;
  pageNumber: number = 1;
  pagingModel: PagingModel = new PagingModel();
  mobileDeviceReviewList: MobileReviewListingModel = new MobileReviewListingModel();
  PagingReviewModel: any;

  constructor(private fb: FormBuilder, private reviewManagementService: ReviewManagementService, private modalService: NgbModal, private homePageService: HomePageService, private activatedRoute: ActivatedRoute, private elRef: ElementRef) {
  }

  ngOnInit() {
    this.reviewList();
  }

  reviewList() {
    this.Loader = true;
    this.PagingReviewModel = this.reviewListModel;
    this.reviewManagementService.reviewListing(this.PagingReviewModel)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.reviewsList.ProductSort = responseBody.responseData;
            this.reviewsList.ProductSort.forEach((element, index) => {
            this.reviewsList.ProductSort[index].imageLoader = true;
            this.reviewManagementService.ReviewImageList(element.id)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  this.reviewsList.ProductSort[index].image = responseimage.responseData;
                  this.reviewsList.ProductSort[index].imageLoader = false;                  
                } (err) => {
                }
              })
          });
          this.Loader = false;
        } (err) => {
        }
      })
  }

  shopReviewData(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
    modalRef.componentInstance.name = item.name;
    modalRef.componentInstance.title = item.title;
    modalRef.componentInstance.comments = item.comments;
  }

}
